import SubscriptionPackage from './SubscriptionPackage';

export default SubscriptionPackage;
